// extracted by mini-css-extract-plugin
export default {"goBackLink":"PaymentGoBackButton_goBackLink__l7W8m"};